// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"352":"1bffa50f","750":"f4fff63d"}[chunkId] + ".chunk.css";
};